module.exports = __webpack_public_path__ + "static/img/areaA-12.249deb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-12.png
// module id = 932
// module chunks = 1